module.exports = __webpack_public_path__ + "img/graduate-2007-mazaixin.708c524b.jpg";